import { __decorate } from 'tslib';
import { Directive, Optional, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, DefaultValueAccessor } from '@angular/forms';
import { TUI_VALUE_ACCESSOR } from '@taiga-ui/core/tokens';

import * as ɵngcc0 from '@angular/core';
function fallbackAccessorFactory(accessor, fallback) {
    return accessor ? accessor[0] : fallback;
}
let TuiMaskAccessorDirective = class TuiMaskAccessorDirective {
};
TuiMaskAccessorDirective.ɵfac = function TuiMaskAccessorDirective_Factory(t) { return new (t || TuiMaskAccessorDirective)(); };
TuiMaskAccessorDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiMaskAccessorDirective, selectors: [["input", "tuiMaskAccessor", ""]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                deps: [[new Optional(), TUI_VALUE_ACCESSOR], DefaultValueAccessor],
                useFactory: fallbackAccessorFactory,
                multi: true
            },
        ])] });

/**
 * @internal
 */
let TuiMaskAccessorModule = class TuiMaskAccessorModule {
};
TuiMaskAccessorModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiMaskAccessorModule });
TuiMaskAccessorModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiMaskAccessorModule_Factory(t) { return new (t || TuiMaskAccessorModule)(); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiMaskAccessorDirective, [{
        type: Directive,
        args: [{
                selector: 'input[tuiMaskAccessor]',
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        deps: [[new Optional(), TUI_VALUE_ACCESSOR], DefaultValueAccessor],
                        useFactory: fallbackAccessorFactory,
                        multi: true
                    },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiMaskAccessorModule, { declarations: [TuiMaskAccessorDirective], exports: [TuiMaskAccessorDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiMaskAccessorModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiMaskAccessorDirective],
                exports: [TuiMaskAccessorDirective]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiMaskAccessorDirective, TuiMaskAccessorModule, fallbackAccessorFactory };

//# sourceMappingURL=taiga-ui-core-directives-mask-accessor.js.map